import { types } from 'actions/project_actions'
import conditions from './conditions'

const handleId = (state = null, action) => {
  if (action.type === action.LOAD_TAG) { return action.tag.id }
  return state
}

const DEFAULT_ELEMENT_FIELDS = {
  group: { type: 'group' },
  condition: { type: 'condition', condition: { table: 'elements' } },
}

const DEFAULT_LOCATION_FIELDS = {
  group: { type: 'group' },
  condition: { type: 'condition', condition: { table: 'locations' } },
}

const initialState = {
  id: null,
  conditions_for_locations: null,
  conditions_for_elements: null,
}

export default function (state = initialState, action) {
  return {
    id: handleId(state.id, action),
    conditions_for_locations: conditions(state.conditions_for_locations, action, 'conditions_for_locations', DEFAULT_LOCATION_FIELDS),
    conditions_for_elements: conditions(state.conditions_for_elements, action, 'conditions_for_elements', DEFAULT_ELEMENT_FIELDS),
  }
}
